import { Button } from '@jove-frontend/uikit';
import { lintrk } from 'nextjs-linkedin-insight-tag';
import { useAnalytics } from 'use-analytics';
import { jsx as _jsx } from "react/jsx-runtime";
var LinkedinConversionId = process.env['NX_LINKEDIN_CONVERSION_ID'];
export var GetQuoteButton = function GetQuoteButton(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      openQuoteModal = _ref.openQuoteModal,
      onClick = _ref.onClick;

  var _useAnalytics = useAnalytics(),
      track = _useAnalytics.track;

  var handleClick = function handleClick() {
    if (onClick) onClick();
    openQuoteModal();
    track('click_get_quote_button');
    lintrk('track', {
      conversion_id: LinkedinConversionId
    });
  };

  return /*#__PURE__*/_jsx(Button, {
    color: type,
    onClick: handleClick,
    children: "Get a quote"
  });
};